export default __webpack_public_path__ + "static/fifth-desktop-796732d21c94e4cf209cefb551e933dd.mp4";